<template>
  <page-outline :title="$t('Webheader.tracking')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <b-row class="text-xl-start mb-3" v-if="type != 'BULKDETAILS' && !flagTOOLBOX">
                <b-col xl="6" lg="9" md="12" cols="12">
                  <b-button-group class="mt-3 mt-sm-0">
                    <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('Webheader.tracking_unit') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('Webheader.tracking_bulk') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 3 ? 'primary btn-selected' : ''" @click="changeTabName(3)">{{ $t('Webheader.orphan') }}</b-button>
                  </b-button-group>
                </b-col>
              </b-row>

              <TrackingList v-if="tabName === 1" :type="TrackType" :id="id"></TrackingList>
              <TrackingBulkPage v-else-if="tabName === 2"></TrackingBulkPage>
              <OprhanFlux v-else-if="tabName === 3"></OprhanFlux>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import conf from '../../config/config.dev.js'
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import TrackingList from './TrackingList.vue'
import TrackingBulkPage from '@/pages/tracking/TrackingBulkPage.vue'
import OprhanFlux from '@/pages/orphan/OrphanFlux.vue'


export default {
  name: 'TrackingPage',
  components: {
    OprhanFlux,
    TrackingBulkPage,
    BackButton,
    TrackingList,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      if (this.tabName == 1) {
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
          { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
        ]
      }
      else {
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },
        ]
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      BIC: '',
      dateBegin: '',
      dateEnd: '',
      displayFilter: false,
      filterBy: '',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      hasDefaultFilter: false,
      IBAN: '',
      identifier: '',
      idTrackAcc: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      returnUrl: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      statusVerification: '',
      tabName: 1,
      technicalStatus: '',
      trackActive: '',
      TracksList: [],
      TrackType: ''
    }
  },
  created () {
    this.$bus.$emit('switch-selected-menu', '/tracking/' + this.type + '/' + this.id)
    if (this.type === 'BULK'){
      this.tabName = 2
    }
    if (this.type == 'Orphan'){
      this.tabName = 3
    }
    if (this.type === 'DDV' || this.type === 'DDD' || this.type === 'BULKDETAILS'){
      this.tabName = 1
      if (this.type !== 'BULKDETAILS') {
        this.TrackType = this.type
      }
      else{
        this.TrackType = 'BULK'
      }
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    changeTabName (tabName) {
      this.tabName = tabName
    }
  }
}
</script>
